import React, {Component} from "react";
import FacebookFriend from "./FacebookFriend";
import LoadingIcon from "./LoadingIcon";
import config from "../config";
import axios from "axios";

class FacebookFriendList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      displayFriends: [],
      areAllContactsLoaded: false
    }
  }

  componentDidMount() {
    let friends = this.props.friends
    friends = this.sortFriends(friends)
    this.filterFriends(friends)
  }

  render() {
    const areAllContactsLoaded = this.state.areAllContactsLoaded
    let friends = this.state.displayFriends

    if (friends.length > 0) {
      friends = friends.map((friend, i) => {
        return (
          <FacebookFriend
            key={i}
            aid={this.props.aid}
            sessionId={this.props.sessionId}
            friend={friend}
            sendInternalInvite={this.props.sendInternalInvite}
          />
        )
      })
    }

    const friendList = (
      <ul className="contacts-list">{friends}</ul>
    )

    // If we haven't finished loading all FacebookContact components, show a loading icon above the friend list
    if (!areAllContactsLoaded) {
      return (
        <div>
          <LoadingIcon/>
          {friendList}
        </div>
      )
    }

    return friendList
  }

  sortFriends(facebookFriends) {
    facebookFriends.sort((a, b) => {
      if (
        a['name'].toString().toLowerCase() ===
        b['name'].toString().toLowerCase()
      ) {
        return 0
      } else if (
        a['name'].toString().toLowerCase() >
        b['name'].toString().toLowerCase()
      ) {
        return 1
      } else if (
        a['name'].toString().toLowerCase() <
        b['name'].toString().toLowerCase()
      ) {
        return -1
      } else return 0 // Our function is confused if it gets here...
    })
    return facebookFriends
  }

  filterFriends(friends) {
    for (let i = 0; i < friends.length; i++) {
      const friend = friends[i]
      // await this.sleep(1000)
      this.validateFriend(friend)
    }
  }

  async sleep(msec) {
    return new Promise(resolve => setTimeout(resolve, msec));
  }

  validateFriend(friend) {
    // Use the Facebook friend handed to us to look up the corresponding Cook'n user,
    // Then to see if that user is already friends with the currenty web app user.
    // If they're friends, we don't have to show the invite button
    // Otherwise, set up the internal invite
    let apiURL =
      config.apiServer +
      '/api/v4/account/auth?asi=' +
      friend.id +
      '&ast=FACEBOOK'

    axios.get(apiURL, {}).then(
      response => {
        // console.log(response)
        if (response.data.key === 'OK') {
          const userJson = response.data.results

          if (userJson.length > 0) {
            friend.cooknData = userJson[0]

            const displayFriends = this.state.displayFriends
            displayFriends.push(friend)

            this.setState((state, props) => ({
              displayFriends: displayFriends
            }))
          }
        }

        // This friend finished loading
        this.onFriendFinishedLoading(friend)
      },
      error => {
        // console.log(error)
        // This friend finished loading
        this.onFriendFinishedLoading(friend)
      }
    )
  }

  loadedFriendCount = 0
  onFriendFinishedLoading = (friend) => {
    console.log("onFriendFinishedLoading: name=[" + friend.name + "], currentLoadedCount=[" + this.loadedFriendCount + "]")

    if (this.state.areAllContactsLoaded) {
      // Avoid re-rendering
      return
    }

    const friends = this.props.friends
    this.loadedFriendCount++
    console.log("onFriendFinishedLoading: incrementedLoadedCount=[" + this.loadedFriendCount + "]")
    const friendCount = friends.length
    console.log("onFriendFinishedLoading: friendCount=[" + friendCount + "]")
    if (this.loadedFriendCount === friendCount) {
      console.log("onFriendFinishedLoading: loaded count matches friend count")
      this.setState((state, props) => ({
        areAllContactsLoaded: true
      }))
    }
  }
}

export default FacebookFriendList


// WEBPACK FOOTER //
// ./src/Components/FacebookFriendList.js